import { useContext, useMemo } from "react";
import { PlayerContext } from "../../backend/PlayerContext";
import { VisibilityContext } from "./VisibilityContext";

export function PlayerContextFreezer(props: {
  isVisible: boolean;
  children: any;
}) {
  const playerContext = useContext(PlayerContext);
  return useMemo(() => {
    return (
      <VisibilityContext.Provider value={props.isVisible}>
        <PlayerContext.Provider value={playerContext}>
          {props.children}
        </PlayerContext.Provider>
      </VisibilityContext.Provider>
    );
  }, [props.isVisible ? playerContext : false]);
}
